<template>
  <div class="mkxq">
    <div v-wechat-title="$route.meta.title"></div>

    <div class="dhtBox">
      <div class="cdBox">
      <div class="logo"></div>

        <div @click="shouye" class="cd">首页</div>
        <div @click="fuwu" class="cd">产品服务</div>
        <div @click="sxy" class="cd">商学院</div>
        <div @click="cpgyl" class="cd">产品供应链</div>
        <div @click="hzal" class="cd">合作案例</div>
        <div @click="ydd( hsk )" class="cd yddapp">
          移动端
          <div class="yddxiazai" v-if="hsk == 2">
            <div class="hezi">
              <!-- <div class="img img1"></div> -->
              <!-- <div class="text">米商云</div> -->
            </div>
            <div class="hezi">
              <div class="img img2">
                <img src="../../assets/images/9774f492e19d7134dca0552612911f5.jpg" alt="">
              </div>
              <div class="text">米小礼</div>
            </div>
            <div class="hezi">
              <!-- <div class="img img3"></div> -->
              <!-- <div class="text">商e通</div> -->
            </div>
          </div>
        </div>
        <!-- <div @click="mk" class="cd bxz">米珈</div> -->
        <div @click="gywm" class="cd">关于我们</div>
      </div>
    </div>
    <div class="shipinneirongboxbox">
      <div class="shipinneirongbox">
        <div class="shipinneirongtext1">米创集团和红星美凯龙商家签约</div>
        <div class="shipinneirongtext2">2021 - 10 - 09</div>
        <div class="boxboxbox">
          <div class="shipinneirongleft">
            <div class="shipins"></div>
            <div class="neirongjianjie">
              <div class="textss">内容简介</div>
              <div class="textimg">
                <div class="textimgtext">分享：</div>
                <div class="textimgs textqq"></div>
                <div class="textimgs textwx"></div>
                <div class="textimgs textwb"></div>
              </div>
            </div>
            <div class="shipinjiandi">
              数字营销大数据后台，深度解析零售大数据，掌握客户掌握客户群众属性分布以数掌握客户群众属性分布以数据驱动
              营销，群众属性分布以数据驱动营销，便捷高效
              客户群众属性分布以数据驱动营销，便捷高效客户群众属性分布以数据驱动营销，便捷高客户群众属性分布以数据驱
              动营销效客户群众属性分布以数据驱动营销，便捷高。
            </div>
          </div>
          <div class="biaotutt">
            <div class="biaotiybox">
              <div class="biaotiy">米咖推荐</div>
              <div class="biaotiy2">自动连播</div>
            </div>
            <div class="shipinlistbox">
              <div class="saobi">
                <div class="splistbox">
                  <div class="splistimg splistimg1"></div>
                  <div class="splisttextbox">
                    <div class="splisttext1">
                      1钜惠某木门·衣柜店活 动案例动案例木门
                    </div>
                    <div class="splisttext2">2021 - 10 - 09</div>
                  </div>
                </div>
                <div class="xiaohenggang"></div>
              </div>
              <div class="saobi">
                <div class="splistbox">
                  <div class="splistimg splistimg1"></div>
                  <div class="splisttextbox">
                    <div class="splisttext1">
                      1钜惠某木门·衣柜店活 动案例动案例木门
                    </div>
                    <div class="splisttext2">2021 - 10 - 09</div>
                  </div>
                </div>
                <div class="xiaohenggang"></div>
              </div>
              <div class="saobi">
                <div class="splistbox">
                  <div class="splistimg splistimg1"></div>
                  <div class="splisttextbox">
                    <div class="splisttext1">
                      1钜惠某木门·衣柜店活 动案例动案例木门
                    </div>
                    <div class="splisttext2">2021 - 10 - 09</div>
                  </div>
                </div>
                <div class="xiaohenggang"></div>
              </div>
              <div class="saobi">
                <div class="splistbox">
                  <div class="splistimg splistimg1"></div>
                  <div class="splisttextbox">
                    <div class="splisttext1">
                      1钜惠某木门·衣柜店活 动案例动案例木门
                    </div>
                    <div class="splisttext2">2021 - 10 - 09</div>
                  </div>
                </div>
                <div class="xiaohenggang"></div>
              </div>
              <div class="saobi">
                <div class="splistbox">
                  <div class="splistimg splistimg1"></div>
                  <div class="splisttextbox">
                    <div class="splisttext1">
                      1钜惠某木门·衣柜店活 动案例动案例木门
                    </div>
                    <div class="splisttext2">2021 - 10 - 09</div>
                  </div>
                </div>
                <div class="xiaohenggang"></div>
              </div>
              <div class="saobi">
                <div class="splistbox">
                  <div class="splistimg splistimg1"></div>
                  <div class="splisttextbox">
                    <div class="splisttext1">
                      1钜惠某木门·衣柜店活 动案例动案例木门
                    </div>
                    <div class="splisttext2">2021 - 10 - 09</div>
                  </div>
                </div>
                <div class="xiaohenggang"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import API from "@/service/common.service.js";

export default {
  data() {
    //

    return {
      active: 0,
      hsk:1,

    };
  },
  mounted() {},
  methods: {
    inputRef1: function () {
      console.log(this.$refs.name1.value);
      this.name1 = this.$refs.name1.value;
    },
    inputRef2: function () {
      console.log(this.$refs.name2.value);
      this.name2 = this.$refs.name2.value;
    },
    inputRef3: function () {
      console.log(this.$refs.name3.value);
      this.name3 = this.$refs.name3.value;
    },
    inputRef4: function () {
      console.log(this.$refs.name4.value);
      this.name4 = this.$refs.name4.value;
    },
    ziliao() {
      console.log(this.name1);
      console.log(this.name2);
      console.log(this.name3);
      console.log(this.name4);
      if (
        this.name1 == "" ||
        this.name1 == "name1" ||
        this.name1 == undefined
      ) {
        this.$toast("请输入您的姓名");
      } else if (
        this.name2 == "" ||
        this.name2 == "name2" ||
        this.name2 == undefined
      ) {
        this.$toast("请输入您的手机号");
      } else if (
        this.name3 == "" ||
        this.name3 == "name3" ||
        this.name3 == undefined
      ) {
        this.$toast("请输入您的公司名称");
      } else if (
        this.name4 == "" ||
        this.name4 == "name4" ||
        this.name4 == undefined
      ) {
        this.$toast("请输入您的省份");
      } else {
        this.tech_www();
      }
    },
    ydd(e){
       if(e == 1){
        this.hsk = 2
      }else{
        this.hsk = 1

      }
      console.log(this.hsk)
      
    },
    shouye() {
      this.$router.push({
        path: "/",
      });
    },
    fuwu() {
      this.$router.push({
        path: "/cpfu",
      });
    },
    sxy() {
      this.$router.push({
        path: "/sxy",
      });
    },
    cpgyl() {
      this.$router.push({
        path: "/cpgyl",
      });
    },
    hzal() {
      this.$router.push({
        path: "/hzal",
      });
    },
    mk() {
      this.$router.push({
        path: "/mk",
      });
    },
    gywm() {
      this.$router.push({
        path: "/gywm",
      });
    },
    // 数据提交
    tech_www() {
      let form_data = new FormData();
      // 姓名
      form_data.append("name", this.name1);
      // 电话
      form_data.append("jobs", this.name2);
      // 需求
      form_data.append("company", this.name3);
      // 省份
      form_data.append("province", this.name4);
      // // 身份证反面照片
      // form_data.append("idcardReversePhoto", this.idcardReversePhoto);

      API.tech_www(form_data).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          // this.typeofwork = res.data.dicList;
          // this.$router.push({
          //   path: "/success"
          // });
          this.$toast(res.data.msg);
        } else {
          // 弹出返回文字
          this.$toast(res.data.msg);
        }
      });
    },
  },
};
</script>
<style lang="scss">
.mkxq {
  font-size: 0.16rem;
  background: #fff;
  .dhtBox {
    background: #fff;
    border: 1px solid #e5e4e4;
    .logo {
      background: url("../../assets/images/123213.png");
    }
    .cdBox {
      .cd {
        color: #000;
      }
      .cd:hover {
        border-bottom: 2px solid #000000;
      }

    .bxz{
      border-bottom: 2px solid #000;
    }
  
    }
  }
  .shipinneirongboxbox {
    width: 100%;
    background: #fff;
    padding-top: 0.7rem;
    .shipinneirongbox {
      width: 1200px;
      margin: 0 auto;
      padding-bottom: 0.5rem;
      .shipinneirongtext1 {
        margin-bottom: 0.2rem;
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;
      }
      .shipinneirongtext2 {
        margin-bottom: 0.47rem;
        font-size: 0.16rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #9b9a9a;
        line-height: 0.3rem;
      }
      .boxboxbox {
        display: flex;
        flex-wrap: wrap;
        .shipinneirongleft {
          width: 7.28rem;
          margin-right: 0.1rem;
          .shipins {
            width: 7.28rem;
            height: 4.09rem;
            background: url("../../assets/images/1714.png") no-repeat center;
            background-size: 100% 100%;
            margin-bottom: 0.3rem;
          }
          .shipinjiandi {
            font-size: 0.14rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
            line-height: 0.4rem;
          }
          .neirongjianjie {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .textss {
              font-size: 0.2rem;
              font-family: Source Han Sans CN;
              font-weight: 500;
              color: #000000;
            }
            .textimg {
              font-size: 0.16rem;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #5f6364;
              line-height: 0.57rem;
              display: flex;
              justify-content: center;
              align-items: center;
              .textimgs {
                width: 0.22rem;
                height: 0.22rem;
                background-size: 100% 100%;
                margin-left: 0.27rem;
              }
              .textqq {
                background: url("../../assets/images/qqs.png") no-repeat center;
              }
              .textwx {
                background: url("../../assets/images/wxs.png") no-repeat center;
              }
              .textwb {
                background: url("../../assets/images/wbs.png") no-repeat center;
              }
            }
          }
        }
        .biaotutt {
          width: 4.58rem;
          height: 6.57rem;
          background: #fbfbfb;
          padding: 0.2rem;
          box-sizing: border-box;
          .biaotiybox {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 0.1rem;
            .biaotiy {
              font-size: 0.2rem;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #000000;
            }
            .biaotiy2 {
              font-size: 0.16rem;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #2d60fe;
              line-height: 0.26rem;
            }
          }

          .shipinlistbox {
            height: 5.8rem;
            overflow: hidden scroll;
            .splistimg {
              width: 2.19rem;
              height: 1.16rem;
              background-size: 100% 100%;
              margin-right: 0.1rem;
            }
            .splistimg1 {
              background: url("../../assets/images/g1.png") no-repeat center;
            }
            .saobi {
              .splistbox {
                display: flex;
                flex-wrap: wrap;
                margin-bottom: 0.1rem;
                .splisttextbox {
                  width: 1.8rem;
                  position: relative;
                  .splisttext1 {
                    font-size: 0.17rem;
                    font-family: Source Han Sans CN;
                    font-weight: 600;
                    color: #121212;
                    line-height: 0.27rem;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    line-clamp: 3;
                    -webkit-box-orient: vertical;
                  }
                  .splisttext2 {
                    position: absolute;
                    bottom: 0.1rem;
                    font-size: 0.15rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #9b9a9a;
                    line-height: 0.31rem;
                  }
                }
              }
              .xiaohenggang {
                margin: 0 auto;
                width: 2.89rem;
                height: 0.01rem;
                background: #EBEBEB;
                margin-bottom: 0.1rem;
                
              }
              
            }
            .saobi:nth-last-child(1) > .xiaohenggang {
                height: 0rem;
              }
          }
        }
      }
    }
  }

  .nr1Box {
    width: 100%;
    height: 11.57rem;
    background: url("../../assets/images/ssss.png") no-repeat center;
    background-size: 100% 100%;
    .nr {
      width: 12rem;
      margin: 0 auto;
      display: flex;
      .nrLeft {
        width: 5.5rem;
        margin-top: 2.5rem;
        margin-right: 0.5rem;
        .nrLeftText1 {
          font-size: 0.32rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #000000;
          display: flex;
          // justify-content: center;
          align-items: center;
          margin-bottom: 0.3rem;
        }
        .nrLeftText2 {
          font-size: 0.14rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #6c6c6c;
          line-height: 38px;
          margin-bottom: 0.3rem;
        }
        .nrLeftText3 {
          width: 4.05rem;
          height: 1.08rem;
          background: #ffffff;
          box-shadow: -0.01rem 0.05rem 0.3rem 0rem rgba(0, 0, 0, 0.1);
          border-radius: 0.2rem;
          font-size: 0.32rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #2b79f5;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 0.5rem;
          margin-left: 0.2rem;
        }
        .nrLeftText4 {
          width: 4.05rem;
          height: 1.08rem;
          background: #ffffff;
          box-shadow: -0.01rem 0.05rem 0.3rem 0rem rgba(0, 0, 0, 0.1);
          border-radius: 0.2rem;
          font-size: 0.32rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #2b79f5;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 0.5rem;
          margin-left: 1.18rem;
        }
        .nrLeftText4s {
          margin-left: 0.2rem;
          background: #4273fd;
          color: #fff;
        }
        .nrLeftText3 {
          width: 4.05rem;
          height: 1.08rem;
          background: #ffffff;
          box-shadow: -0.01rem 0.05rem 0.3rem 0rem rgba(0, 0, 0, 0.1);
          border-radius: 0.2rem;
          font-size: 0.32rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #2b79f5;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 0.5rem;
        }
        .nrLeftText3s {
          margin-left: 1.44rem;
          background: #4273fd;
          color: #fff;
        }
      }
      .nrLefts {
        margin-right: 0;
      }
      .nrRight {
        width: 5rem;
        margin-left: 1rem;
        margin-top: 0.78rem;
        .img {
          display: block;
          width: 4.56rem;
          height: 9.33rem;
          margin: 0 auto;
        }
      }
      .nrRights {
        margin-left: 0rem;
        margin-top: 0rem;
        margin-right: 1.5rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mkxq/index.vue